<template>
  <section class="section" style="margin-top: -40px;">
    <div class="container no-print">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            ລາຍການອອກຕະຫຼາດ ({{ username }})
          </h2>
        </div>
      </div>
      <!-- <div class="columns" style=" margin-top: -40px;">
        <div class="column">
            ຍອດເງິນ: <span style="color:red; font-size: 24px; margin-left: 5px; margin-right: 5px;"> {{ accountBalance | formatNumberLocal }} </span> ກີບ
          
        </div>
      </div> -->
      <b-tabs v-model="activeTab" v-if="roleid == 29">
        
        <b-tab-item label="ການອອກຕະຫຼາດ">
         
          <b-tabs v-model="activeSubTab">
        
            <b-tab-item label="ລາຍການ (1)">
            
              <!-- <b-field>
                <b-button
                  class="btn-group-margin"
                  type="is-info"
                  @click="goToAnotherMarket()"
                  >ໄປຕະຫຼາດລາວ  
                </b-button>
              </b-field> -->
              <b-field>
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                    
                      <th class="has-text-centered " width="10%">
                        ວັນທີ 
                      </th>
                      <th class="has-text-right " width="30%">
                        ຈຳນວນເງິນ
                      </th>
                      <!-- <th class="has-text-centered " width="30%">
                        ລາຍລະອຽດ
                      </th> -->
                    
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data) in purchaselist"
                      :key="data.ID"
                    >
                      <td class="has-text-centered" v-if="data.STATUS ==2" style="background-color: lightgray;">
                        {{ dateFormatter(data.REDATE)  }} - <span style="color: red;">{{ data.MARKETBATCHID }}</span>  
                        <br>
                        <span style="color: red">{{ data.COUNTPRODUCT | formatNumberLocal }}/ {{ data.COUNTMARKETQUANTITY | formatNumberLocal }}</span> ສິນຄ້າ
                      </td>
                      <td class="has-text-centered" v-else>
                        {{ dateFormatter(data.REDATE)  }} - <span style="color: red;">{{ data.MARKETBATCHID }}</span>  
                        <br>
                        <span style="color: red">{{ data.COUNTPRODUCT | formatNumberLocal }}/ {{ data.COUNTMARKETQUANTITY | formatNumberLocal }}</span> ສິນຄ້າ
                      </td>
                      <td class="has-text-right" v-if="data.STATUS ==2" style="background-color: lightgray;">
                        {{ data.TOTAL | formatNumberLocal }}<br>
                        <span v-if="data.STATUS ==2" style="color: red;">
                          ຢືນຢັນລາຍການແລ້ວ
                          <br>
                        </span>
                        <b-button
                          class="btn-group-margin"
                          type="is-info"
                          @click="purchaseProductList(data.REDATE, data.MARKETBATCHID, 2)"
                          >ລາຍລະອຽດ  
                        </b-button>
                      </td>
                      <td class="has-text-right" v-else>
                        {{ data.TOTAL | formatNumberLocal }}<br>
  
                        <b-button
                          class="btn-group-margin"
                          type="is-info"
                          @click="purchaseProductList(data.REDATE, data.MARKETBATCHID, 2)"
                          >ລາຍລະອຽດ  
                        </b-button>
                      </td>
                      <!-- <td class="has-text-centered" v-if="data.STATUS ==2" style="background-color: lightgray;">
                        <span v-if="data.STATUS ==2" style="color: red;">
                          ຢືນຢັນລາຍການແລ້ວ
                          <br>
                        </span>
                        <b-button
                        class="btn-group-margin"
                        type="is-info"
                        @click="purchaseProductList(data.REDATE, data.MARKETBATCHID, 2)"
                        >ລາຍລະອຽດ  
                      </b-button>
                      </td>
                      <td class="has-text-centered" v-else>
                        <b-button
                        class="btn-group-margin"
                        type="is-info"
                        @click="purchaseProductList(data.REDATE, data.MARKETBATCHID, 2)"
                        >ລາຍລະອຽດ  
                      </b-button>
                          
                      </td> -->
                    
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </b-tab-item>
            <b-tab-item label="ລາຍລະອຽດ (2)">
            
              <b-field label="" v-if="isPrintData==0">
                <div class="columns">
                  <div class="column" >
                    <label slot="label">
                      ລາຍການສັ່ງຊື້: <span style="font-weight: bold;">{{ dateFormatter(selectedPurchaseDate) }}</span>
                    </label>
                    <br>
                    <!-- <label slot="label" v-if="productRemainConfirm != 0">
                    ຍອດເງິນ: <span style="font-weight: bold; color: red;">{{ accountBalance | formatNumberLocal }}</span><br>
                    </label> -->
                    <!-- <label slot="label" v-if="productRemainConfirm != 0">
                    ຈຳນວນທີ່ຊື້---: <span style="font-weight: bold;  color: red;">{{ selectedPurchaseDateAmount | formatNumberLocal }}</span><br>
                    </label> -->
                    <!-- <label slot="label" v-if="productRemainConfirm != 0">
                    ຍັງເຫຼືອ: <span style="font-weight: bold;  color: red;">{{ (accountBalance-selectedPurchaseDateAmount) | formatNumberLocal }}</span>
                    </label> -->
                    <b-field grouped style="margin-top: 0px;">
                      <b-field>
                        <label >
                        ຈຳນວນທີ່ຊື້: <span style="font-weight: bold;  color: red;">{{ selectedPurchaseDateAmount | formatNumberLocal }}</span><br>
                        </label>
                      </b-field>
                    </b-field>
                    <b-field grouped style="margin-top: -10px;">
                      <b-field>
                        <label >
                        ຈຳນວນທີ່ໃຊ້ບັນຊີ: 
                        </label>
                      </b-field>  
                    
                      <b-field>
                        <span v-if="(checkStatus==1 || checkStatus==2) && isEditCheckAmount ==0" style="font-weight: bold;  color: red;">{{ sysAmount | formatNumberLocal }}</span>
                        
                      </b-field>
                      <b-field v-if="checkStatus==0 || isEditCheckAmount ==1">
                        <b-input 
                          v-model.trim="sysAmount"   
                          type="number"   
                          min="0" 
                          class="text-right-input"
                          placeholder="ຈຳນວນເງິນ"
                          style="width: 150px;text-align: right;" 
                          @input="sysAccountPress"
                        >
                        </b-input> 
                      
                      </b-field>
                    </b-field>
                    <b-field grouped style="margin-top: -10px; margin-bottom: 25px;">
                      <b-field> 
                        <b-button v-if="checkStatus==0"
                          class="btn-group-margin"
                          type="is-success"   
                          @click="saveMarketAccount()"
                          >ບັນທຶກບັນຊີ 
                        </b-button>

                        <b-button v-if="checkStatus == 1 && isEditCheckAmount ==0"
                          class="btn-group-margin"
                          type="is-warning"   
                          @click="editMarketAccountForm()"
                          >ແກ້ໄຂ 
                        </b-button>

                        <b-button v-if="checkStatus == 1 && isEditCheckAmount ==1"
                          class="btn-group-margin"
                          type="is-danger"   
                          @click="editMarketAccount()"
                          >ແກ້ໄຂ 
                        </b-button>
                        
                      </b-field>
                      <b-field>
                        <span v-if="(checkStatus==2)" style="font-weight: bold;  color: white; background-color: red; margin-left: 20px; padding: 0px 5px 0px 5px;">ສະຫຼຸບບັນຊີປະຈຳວັນແລ້ວ</span>
                      </b-field>
                    </b-field>
                    <b-field grouped style="margin-top: -30px;">     
                      <b-field>
                        <label slot="label">
                          ສ່ວນຕ່າງ: <span style="font-weight: bold; color: red;">{{ diffAmount | formatNumberLocal }}</span><br>
                        </label>
                      </b-field>
                    </b-field>
                    <b-field grouped style="margin-top: -10px;">   
                    
                      <b-field v-if="isArrivedLaoMarket ==0 ">
                        <b-button  
                          class="btn-group-margin"
                          type="is-danger"   
                          @click="checkInMarket()"
                          >ຮອດຕະຫຼາດລາວ   
                        </b-button>
                      </b-field>
                      <b-field v-else style="color: red;">
                        ຮອດຕະຫຼາດລາວ: {{ laomarketttime }}
                      </b-field>

                    </b-field>
                    <!-- <b-field grouped style="margin-top: -20px;" v-if="MOREMARKETTIME != null">
                      ຮອດຕະຫຼາດລາວ: {{ MOREMARKETTIME }}
                    </b-field>    -->
                    
                    
                  </div>
                  

                  <div class="column" style=" padding: 0; margin: 0; text-align: right;">
                    <!-- <b-button v-if="productRemainConfirm != 0"
                      class="btn-group-margin"
                      type="is-danger"  
                      @click="confirmAllPurchaseMarket()"
                      >ຢືນຢັນຄວາມຖືກຕ້ອງ 
                    </b-button> -->
                  </div>
                  <div class="column" style=" padding: 0; margin: 0; text-align: right;">
                    <b-button v-if="productRemainConfirm != 0 && selectedPurchaseMarketID ==8"
                      class="btn-group-margin"
                      type="is-success"  
                      @click="getPurchaserData()"
                      >ດືງລາຍການ ເພື່ອພິມ 
                    </b-button>
                  </div>
                </div>
              </b-field>

              <!-- <table class="table is-fullwidth is-narrow is-small" v-if="isPrintData==0">
                <thead>
                  <tr>
                    <th class="has-text-left " width="50%">
                      ສິນຄ້າ
                    </th>
                    <th class="has-text-centered " width="10%">
                      ຈຳນວນ
                    </th>
                    <th class="has-text-right " width="30%">
                      ລາຍລະອຽດ
                    </th>
                    
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in productList"
                    :key="data.PRODUCTANDTYPE"
                  >
                    <td class="has-text-left">
                      {{index +1 }}. {{ data.PRODUCTNAME  }} <br> 
                      <span style="color: red;"> {{ parseInt(data.TOTALPRICE / data.MARKETQUANTITY) | formatNumberLocal }}/ ກິໂລ</span><br>
                      <span style="color: red;"> {{  parseInt(data.TOTALPRICE / data.MARKETQUANTITY * 12) | formatNumberLocal }}/ ໝື່ນ</span> 
                      <br>F: {{ data.FIRSTTIME }}
                      <br>L: {{ data.LASTTIME }}
                      <br>
                      <img
                        class="image-area"
                        style="width: 100%; max-width: 100px;"
                        :src="getImgUrl('products/' + data.PHOTONAME)"
                        @click="showPopup(data.PHOTONAME)"
                        
                      />  
                    
                      <div v-if="data.STATUS == 1 && parseFloat(data.MARKETQUANTITY) < parseFloat(data.QUANTITY) " style=" margin-top: -5px; margin-bottom: 10px; ">
                        <b-button v-if="data.NEED_TO_UPDATE==0 && data.OKFEE !=1"  
                          class="btn-group-margin"
                          type="is-primary"
                          size="is-small"   
                          @click="transferProductForm(index)"  
                          >ໂອນສິນຄ້າ 
                        </b-button>
                        <b-field v-if="data.NEED_TO_UPDATE== 1">
                          <b-field style="margin-right: 10px "> 
                            <b-input 
                              v-model.trim="data.REMAINQUANTITY"
                              type="number"  
                              min="0.1"
                              step="0.1"
                              pattern="[0-9]+([.][0-9]+)?"
                              class="text-right-input"
                              placeholder="ຈຳນວນ"
                              style="width: 100px;text-align: right;"
                            >
                            </b-input>
                          </b-field>
                          <b-field>
                            <Multiselect
                              placeholder="ເລືອກຕະຫຼາດ"
                              v-model.trim="data.SELECTEDMARKET"  
                              label="NAME"
                              track-by="ID"
                              :options="marketList"
                              @input="transferProduct(index)"
                            >  
                            </Multiselect>
                          </b-field>
                        </b-field>
                      </div>
                    </td>
                    <td class="has-text-right" v-if="data.STATUS == 2 && parseFloat(data.MARKETQUANTITY) == 0 " style="background-color: red; color: white;">
                          {{ data.QUANTITY | formatNumberLocal }} / {{ data.MARKETQUANTITY | formatNumberLocal }} <span style="color: red; font-weight: bold;"> {{ data.UNIT }}</span>
                          <br> 
                          <span v-if="parseFloat(data.MARKETQUANTITY) > 0 ">
                            {{ data.TOTALPRICE | formatNumberLocal }}  
                          </span>
                          
                    </td>
                    <td class="has-text-right" v-else-if=" data.STATUS == 2 && (parseFloat(data.MARKETQUANTITY) > 0  ) && parseFloat(data.QUANTITY) > parseFloat(data.MARKETQUANTITY) " style="background-color: yellow;">
                          {{ data.QUANTITY | formatNumberLocal }} / {{ data.MARKETQUANTITY | formatNumberLocal }} <span style="color: red; font-weight: bold;"> {{ data.UNIT }}</span>
                          <br> 
                          <span v-if="parseFloat(data.MARKETQUANTITY) > 0 ">
                            {{ data.TOTALPRICE | formatNumberLocal }}  
                          </span>  
                          
                    </td>
                    <td class="has-text-right" v-else-if="  data.STATUS == 1  && (parseFloat(data.MARKETQUANTITY) > 0 ) && parseFloat(data.QUANTITY) == parseFloat(data.MARKETQUANTITY) " style="background-color: green; color: white;">
                          {{ data.QUANTITY | formatNumberLocal }} / {{ data.MARKETQUANTITY | formatNumberLocal }} <span style="color: red; font-weight: bold;"> {{ data.UNIT }}</span>
                          <br> 
                          <span v-if="parseFloat(data.MARKETQUANTITY) > 0 ">
                            {{ data.TOTALPRICE | formatNumberLocal }}  
                          </span>
                          
                    </td>
                    <td class="has-text-right" v-else>
                          {{ data.QUANTITY | formatNumberLocal }} / {{ data.MARKETQUANTITY | formatNumberLocal }} <span style="color: red; font-weight: bold;"> {{ data.UNIT }}</span>
                          <br>
                          <span v-if="parseFloat(data.MARKETQUANTITY) > 0 ">  
                            {{ data.TOTALPRICE | formatNumberLocal }}  
                          </span>
                    </td>  
                    <td class="has-text-right">
                      <b-button
                        class="btn-group-margin"
                        type="is-info"
                        size="is-small"
                        @click="purchaseProductSubList(data.PURCHASEMARKETID, data.PRODUCTID, data.PRODUCTNAME, data.MARKETID, data.QUANTITY, data.MARKETQUANTITY, data.STATUS, data.ISGROUPBUY )"
                        >ລາຍລະອຽດ 
                      </b-button>
                    </td>
                    
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th  class="has-text-right">
                      ລວມ 
                    </th>
                    <th  class="has-text-right">
                      {{ _.sumBy(productList, i => i["TOTALPRICE"]) | formatNumberLocal }}
                    </th>
                    <th class="has-text-right">
                      
                    </th>                 
                  </tr>
                </tfoot> 
              </table> -->

              <b-tabs v-model="activeSub3Tab" v-if="isPrintData==0">
        
                <b-tab-item label="ຍັງບໍ່ປ້ອນ">
                  <table class="table is-fullwidth is-narrow is-small" >
                    <thead>
                      <tr>
                        <th class="has-text-left " width="50%">
                          ສິນຄ້າ
                        </th>
                        <th class="has-text-centered " width="10%">
                          ຈຳນວນ
                        </th>
                        <th class="has-text-right " width="30%">
                          ລາຍລະອຽດ
                        </th>
                        
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(data, index) in nobuyList"
                        :key="data.PRODUCTANDTYPE"
                      >
                        <td class="has-text-left">
                          {{index +1 }}. {{ data.PRODUCTNAME  }} <br> 
                          <span style="color: red;"> {{ parseInt(data.TOTALPRICE / data.MARKETQUANTITY) | formatNumberLocal }}/ ກິໂລ</span><br>
                          <span style="color: red;"> {{  parseInt(data.TOTALPRICE / data.MARKETQUANTITY * 12) | formatNumberLocal }}/ ໝື່ນ</span> 
                          <br>F: {{ data.FIRSTTIME }}
                          <br>L: {{ data.LASTTIME }}
                          <br>
                          <img
                            class="image-area"
                            style="width: 100%; max-width: 100px;"
                            :src="getImgUrl('products/' + data.PHOTONAME)"
                            @click="showPopup(data.PHOTONAME)"
                            
                          />  
                        
                          <div v-if="data.STATUS == 1 && parseFloat(data.MARKETQUANTITY) < parseFloat(data.QUANTITY) " style=" margin-top: -5px; margin-bottom: 10px; ">
                            <b-button v-if="data.NEED_TO_UPDATE==0 && data.OKFEE !=1"  
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"   
                              @click="transferProductForm(index)"  
                              >ໂອນສິນຄ້າ 
                            </b-button>
                            <b-field v-if="data.NEED_TO_UPDATE== 1">
                              <b-field style="margin-right: 10px "> 
                                <b-input 
                                  v-model.trim="data.REMAINQUANTITY"
                                  type="number"  
                                  min="0.1"
                                  step="0.1"
                                  pattern="[0-9]+([.][0-9]+)?"
                                  class="text-right-input"
                                  placeholder="ຈຳນວນ"
                                  style="width: 100px;text-align: right;"
                                >
                                </b-input>
                              </b-field>
                              <b-field>
                                <Multiselect
                                  placeholder="ເລືອກຕະຫຼາດ1"
                                  v-model.trim="data.SELECTEDMARKET"  
                                  label="NAME"
                                  track-by="ID"
                                  :options="marketList"
                                  @input="transferProduct(index)"
                                >  
                                </Multiselect>
                              </b-field>
                            </b-field>
                          </div>
                        </td>
                        <td class="has-text-right" v-if="data.STATUS == 2 && parseFloat(data.MARKETQUANTITY) == 0 " style="background-color: red; color: white;">
                              {{ data.QUANTITY | formatNumberLocal }} / {{ data.MARKETQUANTITY | formatNumberLocal }} <span style="color: red; font-weight: bold;"> {{ data.UNIT }}</span>
                              <br> 
                              <span v-if="parseFloat(data.MARKETQUANTITY) > 0 ">
                                {{ data.TOTALPRICE | formatNumberLocal }}  
                              </span>
                              
                        </td>
                        <td class="has-text-right" v-else-if=" data.STATUS == 2 && (parseFloat(data.MARKETQUANTITY) > 0  ) && parseFloat(data.QUANTITY) > parseFloat(data.MARKETQUANTITY) " style="background-color: yellow;">
                              {{ data.QUANTITY | formatNumberLocal }} / {{ data.MARKETQUANTITY | formatNumberLocal }} <span style="color: red; font-weight: bold;"> {{ data.UNIT }}</span>
                              <br> 
                              <span v-if="parseFloat(data.MARKETQUANTITY) > 0 ">
                                {{ data.TOTALPRICE | formatNumberLocal }}  
                              </span>  
                              
                        </td>
                        <td class="has-text-right" v-else-if="  data.STATUS == 1  && (parseFloat(data.MARKETQUANTITY) > 0 ) && parseFloat(data.QUANTITY) == parseFloat(data.MARKETQUANTITY) " style="background-color: green; color: white;">
                              {{ data.QUANTITY | formatNumberLocal }} / {{ data.MARKETQUANTITY | formatNumberLocal }} <span style="color: red; font-weight: bold;"> {{ data.UNIT }}</span>
                              <br> 
                              <span v-if="parseFloat(data.MARKETQUANTITY) > 0 ">
                                {{ data.TOTALPRICE | formatNumberLocal }}  
                              </span>
                              
                        </td>
                        <td class="has-text-right" v-else>
                              {{ data.QUANTITY | formatNumberLocal }} / {{ data.MARKETQUANTITY | formatNumberLocal }} <span style="color: red; font-weight: bold;"> {{ data.UNIT }}</span>
                              <br>
                              <span v-if="parseFloat(data.MARKETQUANTITY) > 0 ">  
                                {{ data.TOTALPRICE | formatNumberLocal }}  
                              </span>
                        </td>  
                        <td class="has-text-right">
                          <b-button
                            class="btn-group-margin"
                            type="is-info"
                            size="is-small"
                            @click="purchaseProductSubList(data.PURCHASEMARKETID, data.PRODUCTID, data.PRODUCTNAME, data.MARKETID, data.QUANTITY, data.MARKETQUANTITY, data.STATUS, data.ISGROUPBUY )"
                            >ລາຍລະອຽດ 
                          </b-button>
                        </td>
                        
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <th  class="has-text-right">
                          ລວມ 
                        </th>
                        <th  class="has-text-right">
                          {{ _.sumBy(productList, i => i["TOTALPRICE"]) | formatNumberLocal }}
                        </th>
                        <th class="has-text-right">
                          
                        </th>                 
                      </tr>
                    </tfoot> 
                  </table>
                </b-tab-item>
                <b-tab-item label="ປ້ອນບາງສ່ວນ">
                  <table class="table is-fullwidth is-narrow is-small">
                    <thead>
                      <tr>
                        <th class="has-text-left " width="50%">
                          ສິນຄ້າ
                        </th>
                        <th class="has-text-centered " width="10%">
                          ຈຳນວນ
                        </th>
                        <th class="has-text-right " width="30%">
                          ລາຍລະອຽດ
                        </th>
                        
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(data, index) in buySomeList"   
                        :key="data.PRODUCTANDTYPE"
                      >
                        <td class="has-text-left">
                          {{index +1 }}. {{ data.PRODUCTNAME  }} <br> 
                          <span style="color: red;"> {{ parseInt(data.TOTALPRICE / data.MARKETQUANTITY) | formatNumberLocal }}/ ກິໂລ</span><br>
                          <span style="color: red;"> {{  parseInt(data.TOTALPRICE / data.MARKETQUANTITY * 12) | formatNumberLocal }}/ ໝື່ນ</span> 
                          <br>F: {{ data.FIRSTTIME }}
                          <br>L: {{ data.LASTTIME }}
                          <br>
                          <img
                            class="image-area"
                            style="width: 100%; max-width: 100px;"
                            :src="getImgUrl('products/' + data.PHOTONAME)"
                            @click="showPopup(data.PHOTONAME)"
                            
                          />  
                        
                          <div v-if="data.STATUS == 1 && parseFloat(data.MARKETQUANTITY) < parseFloat(data.QUANTITY) " style=" margin-top: -5px; margin-bottom: 10px; ">
                            <b-button v-if="data.NEED_TO_UPDATE==0 && data.OKFEE !=1"  
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"   
                              @click="transferProductForm2(index)"  
                              >ໂອນສິນຄ້າ 
                            </b-button>
                            <b-field v-if="data.NEED_TO_UPDATE== 1">
                              <b-field style="margin-right: 10px "> 
                                <b-input 
                                  v-model.trim="data.REMAINQUANTITY"
                                  type="number"  
                                  min="0.1"
                                  step="0.1"
                                  pattern="[0-9]+([.][0-9]+)?"
                                  class="text-right-input"
                                  placeholder="ຈຳນວນ"
                                  style="width: 100px;text-align: right;"
                                >
                                </b-input>
                              </b-field>
                              <b-field>
                                <Multiselect
                                  placeholder="ເລືອກຕະຫຼາດ2"
                                  v-model.trim="data.SELECTEDMARKET"  
                                  label="NAME"
                                  track-by="ID"
                                  :options="marketList"
                                  @input="transferProduct2(index)"
                                >  
                                </Multiselect>
                              </b-field>
                            </b-field>
                          </div>
                        </td>
                        <td class="has-text-right" v-if="data.STATUS == 2 && parseFloat(data.MARKETQUANTITY) == 0 " style="background-color: red; color: white;">
                              {{ data.QUANTITY | formatNumberLocal }} / {{ data.MARKETQUANTITY | formatNumberLocal }} <span style="color: red; font-weight: bold;"> {{ data.UNIT }}</span>
                              <br> 
                              <span v-if="parseFloat(data.MARKETQUANTITY) > 0 ">
                                {{ data.TOTALPRICE | formatNumberLocal }}  
                              </span>
                              
                        </td>
                        <td class="has-text-right" v-else-if=" data.STATUS == 2 && (parseFloat(data.MARKETQUANTITY) > 0  ) && parseFloat(data.QUANTITY) > parseFloat(data.MARKETQUANTITY) " style="background-color: yellow;">
                              {{ data.QUANTITY | formatNumberLocal }} / {{ data.MARKETQUANTITY | formatNumberLocal }} <span style="color: red; font-weight: bold;"> {{ data.UNIT }}</span>
                              <br> 
                              <span v-if="parseFloat(data.MARKETQUANTITY) > 0 ">
                                {{ data.TOTALPRICE | formatNumberLocal }}  
                              </span>  
                              
                        </td>
                        <td class="has-text-right" v-else-if="  data.STATUS == 1  && (parseFloat(data.MARKETQUANTITY) > 0 ) && parseFloat(data.QUANTITY) == parseFloat(data.MARKETQUANTITY) " style="background-color: green; color: white;">
                              {{ data.QUANTITY | formatNumberLocal }} / {{ data.MARKETQUANTITY | formatNumberLocal }} <span style="color: red; font-weight: bold;"> {{ data.UNIT }}</span>
                              <br> 
                              <span v-if="parseFloat(data.MARKETQUANTITY) > 0 ">
                                {{ data.TOTALPRICE | formatNumberLocal }}  
                              </span>
                              
                        </td>
                        <td class="has-text-right" v-else>
                              {{ data.QUANTITY | formatNumberLocal }} / {{ data.MARKETQUANTITY | formatNumberLocal }} <span style="color: red; font-weight: bold;"> {{ data.UNIT }}</span>
                              <br>
                              <span v-if="parseFloat(data.MARKETQUANTITY) > 0 ">  
                                {{ data.TOTALPRICE | formatNumberLocal }}  
                              </span>
                        </td>  
                        <td class="has-text-right">
                          <b-button
                            class="btn-group-margin"
                            type="is-info"
                            size="is-small"
                            @click="purchaseProductSubList(data.PURCHASEMARKETID, data.PRODUCTID, data.PRODUCTNAME, data.MARKETID, data.QUANTITY, data.MARKETQUANTITY, data.STATUS, data.ISGROUPBUY )"
                            >ລາຍລະອຽດ 
                          </b-button>
                        </td>
                        
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <th  class="has-text-right">
                          ລວມ 
                        </th>
                        <th  class="has-text-right">
                          {{ _.sumBy(productList, i => i["TOTALPRICE"]) | formatNumberLocal }}
                        </th>
                        <th class="has-text-right">
                          
                        </th>                 
                      </tr>
                    </tfoot> 
                  </table>
                </b-tab-item>
                <b-tab-item label="ປ້ອນສຳເລັດ">
                  <table class="table is-fullwidth is-narrow is-small">
                    <thead>
                      <tr>
                        <th class="has-text-left " width="50%">
                          ສິນຄ້າ
                        </th>
                        <th class="has-text-centered " width="10%">
                          ຈຳນວນ
                        </th>
                        <th class="has-text-right " width="30%">
                          ລາຍລະອຽດ
                        </th>
                        
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(data, index) in buyAllList"
                        :key="data.PRODUCTANDTYPE"
                      >
                        <td class="has-text-left">
                          {{index +1 }}. {{ data.PRODUCTNAME  }} <br> 
                          <span style="color: red;"> {{ parseInt(data.TOTALPRICE / data.MARKETQUANTITY) | formatNumberLocal }}/ ກິໂລ</span><br>
                          <span style="color: red;"> {{  parseInt(data.TOTALPRICE / data.MARKETQUANTITY * 12) | formatNumberLocal }}/ ໝື່ນ</span> 
                          <br>F: {{ data.FIRSTTIME }}
                          <br>L: {{ data.LASTTIME }}
                          <br>
                          <img
                            class="image-area"
                            style="width: 100%; max-width: 100px;"
                            :src="getImgUrl('products/' + data.PHOTONAME)"
                            @click="showPopup(data.PHOTONAME)"
                            
                          />  
                        
                          <div v-if="data.STATUS == 1 && parseFloat(data.MARKETQUANTITY) < parseFloat(data.QUANTITY) " style=" margin-top: -5px; margin-bottom: 10px; ">
                            <b-button v-if="data.NEED_TO_UPDATE==0 && data.OKFEE !=1"  
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"   
                              @click="transferProductForm(index)"  
                              >ໂອນສິນຄ້າ 
                            </b-button>
                            <b-field v-if="data.NEED_TO_UPDATE== 1">
                              <b-field style="margin-right: 10px "> 
                                <b-input 
                                  v-model.trim="data.REMAINQUANTITY"
                                  type="number"  
                                  min="0.1"
                                  step="0.1"
                                  pattern="[0-9]+([.][0-9]+)?"
                                  class="text-right-input"
                                  placeholder="ຈຳນວນ"
                                  style="width: 100px;text-align: right;"
                                >
                                </b-input>
                              </b-field>
                              <b-field>
                                <Multiselect
                                  placeholder="ເລືອກຕະຫຼາດ3"
                                  v-model.trim="data.SELECTEDMARKET"  
                                  label="NAME"
                                  track-by="ID"
                                  :options="marketList"
                                  @input="transferProduct(index)"
                                >  
                                </Multiselect>
                              </b-field>
                            </b-field>
                          </div>
                        </td>
                        <td class="has-text-right" v-if="data.STATUS == 2 && parseFloat(data.MARKETQUANTITY) == 0 " style="background-color: red; color: white;">
                              {{ data.QUANTITY | formatNumberLocal }} / {{ data.MARKETQUANTITY | formatNumberLocal }} <span style="border-radius: 2px; color: red; background-color: white; font-weight: bold;"> {{ data.UNIT }}</span>
                              <br> 
                              <span v-if="parseFloat(data.MARKETQUANTITY) > 0 ">
                                {{ data.TOTALPRICE | formatNumberLocal }}  
                              </span>   
                              
                        </td>
                        <td class="has-text-right" v-else-if=" data.STATUS == 2 && (parseFloat(data.MARKETQUANTITY) > 0  ) && parseFloat(data.QUANTITY) > parseFloat(data.MARKETQUANTITY) " style="background-color: yellow;">
                              {{ data.QUANTITY | formatNumberLocal }} / {{ data.MARKETQUANTITY | formatNumberLocal }} <span style="border-radius: 2px; color: red; background-color: white; font-weight: bold;"> {{ data.UNIT }}</span>
                              <br> 
                              <span v-if="parseFloat(data.MARKETQUANTITY) > 0 ">  
                                {{ data.TOTALPRICE | formatNumberLocal }}  
                              </span>  
                              
                        </td>
                        <td class="has-text-right" v-else-if="  data.STATUS == 1  && (parseFloat(data.MARKETQUANTITY) > 0 ) && parseFloat(data.QUANTITY) == parseFloat(data.MARKETQUANTITY) " style="background-color: green; color: white;">
                              {{ data.QUANTITY | formatNumberLocal }} / {{ data.MARKETQUANTITY | formatNumberLocal }} <span style=" border-radius: 2px; padding: 0 5px 0 5px; color: red; background-color: white; font-weight: bold;"> {{ data.UNIT }}</span>
                              <br> 
                              <span v-if="parseFloat(data.MARKETQUANTITY) > 0 ">  
                                {{ data.TOTALPRICE | formatNumberLocal }}   
                              </span> 
                              
                        </td>
                        <td class="has-text-right" v-else>
                              {{ data.QUANTITY | formatNumberLocal }} / {{ data.MARKETQUANTITY | formatNumberLocal }} <span style="border-radius: 2px; color: red; background-color: white; font-weight: bold;"> {{ data.UNIT }}</span>
                              <br>
                              <span v-if="parseFloat(data.MARKETQUANTITY) > 0 ">  
                                {{ data.TOTALPRICE | formatNumberLocal }}  
                              </span>
                        </td>  
                        <td class="has-text-right">
                          <b-button
                            class="btn-group-margin"
                            type="is-info"
                            size="is-small"
                            @click="purchaseProductSubList(data.PURCHASEMARKETID, data.PRODUCTID, data.PRODUCTNAME, data.MARKETID, data.QUANTITY, data.MARKETQUANTITY, data.STATUS, data.ISGROUPBUY )"
                            >ລາຍລະອຽດ 
                          </b-button>
                        </td>
                        
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <th  class="has-text-right">
                          ລວມ 
                        </th>
                        <th  class="has-text-right">
                          {{ _.sumBy(productList, i => i["TOTALPRICE"]) | formatNumberLocal }}
                        </th>
                        <th class="has-text-right">
                          
                        </th>                 
                      </tr>
                    </tfoot> 
                  </table>
                </b-tab-item>
              </b-tabs>

                  

              <b-field label="" v-if="isPrintData==1">
                <div class="columns">
                  <div class="column">
                    
                  </div>
                  

                  <div class="column" style=" padding: 0; margin: 0; text-align: right;">
                    
                  </div>
                  <div class="column" style=" padding: 0; margin: 0; text-align: right;">
                    <b-field grouped style="float: right;">
                      <b-field>
                        <b-button style="width: 200px;"
                          class="btn-group-margin"
                          type="is-success"  
                          @click="gobackBuyList()"
                          >ກັບຄືນ
                        </b-button>
                      </b-field>
                      <b-field > 
                        <b-button  style="width: 200px;"
                          class="btn-group-margin"
                          type="is-info"  
                          @click="print()"
                          >ພິມ
                        </b-button>
                      </b-field>
                    </b-field>

                  </div>
                </div>
              </b-field>
              <table class="table is-fullwidth is-narrow is-small" v-if="isPrintData==1">
                <thead>
                  <tr>
                    <th class="has-text-left " width="50%">
                      ສິນຄ້າ
                    </th>
                    <th class="has-text-centered " width="10%">
                      ຈຳນວນ
                    </th>
                   
                    
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in productList"
                    :key="data.PRODUCTID"
                  >
                    <td class="has-text-left">
                      {{index + 1 }}. {{ data.PRODUCTNAME  }} 
                  
                    </td> 
                    <td class="has-text-right"  style="">  
                          <span style=" font-weight: bold;">{{ data.QUANTITY | formatNumberLocal }}</span>  {{ data.UNIT }}
                          
                    </td>
                    
                  </tr>
                </tbody>
                
              </table>
              
            </b-tab-item>
            <b-tab-item label="ສິນຄ້າຍ່ອຍ (3)">
              <div v-if="((selectedProductQuantity == selectedProductMarketQuantity) && selectedProductQuantity > 0) || isConfirmed ==1 ||  selectedProductMarketStatus  ==2" style="margin-bottom: 10px;">  
                <span style="color: red; ">ປ້ອນຄົບ ຫຼື ຢືນຢັນແລ້ວ </span> 
              </div>
              <div v-else>
                <span style="font-size: 16px; font-weight: bold;">ສິນຄ້າທີ່ຕ້ອງການ: <span style="color: red;">{{ selectedProductName}}</span></span> <br>    
                <span v-if="getMarketProductTotalQuantity(productSubList) > selectedProductGroupQuantity"  style="font-size: 16px; font-weight: bold;"> 
                           ຈຳນວນທັງໝົດ: {{ getMarketProductTotalQuantity(productSubList) | formatNumberLocal }} | <span style=" background-color: red; color: white;">ໂອນມາ:  
                                                                                                                             <span style=" padding-left: 10px; padding-right: 10px;">
                                                                                                                                {{ selectedProductGroupQuantity | formatNumberLocal }}
                                                                                                                              </span>
                                                                                                                  </span>
                </span><br>
                <span style="font-size: 16px; font-weight: bold;">ຈຳນວນທີ່ຕ້ອງການ: <span style="color: red;">{{ selectedProductQuantity}}</span> / <span style="color: red">{{selectedProductMarketQuantity }}</span></span> <br>
                
                <span style="font-size: 16px; font-weight: bold;">ຈຳນວນທີ່ຕ້ອງຊື້: {{ selectedProductQuantityRemain }}</span>  
                <b-field grouped>
                  <b-field> 
                    <b-input 
                      v-model.trim="selectedProductQuantityRemain"
                      type="number"   
                      min="0.1"
                      step="0.1"
                      pattern="[0-9]+([.][0-9]+)?"
                      class="text-right-input"
                      placeholder="ຈຳນວນ"
                      style="width: 100px;text-align: right;"
                    >
                    </b-input>
                  
                  </b-field>
                
                  <b-field>
                    <b-input 
                      v-model.trim="productTotalPrice"   
                      type="number"   
                      min="0"
                      pattern="[0-9]+"
                      class="text-right-input"
                      placeholder="ຈຳນວນເງິນ"
                      style="width: 130px;text-align: right;" 
                    >
                    </b-input>
                  
                  </b-field>
                  <b-field>
                    <b-button style="margin-top: 0px;"
                      class="btn-group-margin"
                      type="is-primary"
                      @click="updatePurchaseMarketQuantity(  '','','', 2, '', '','', '','')"
                      >ບັນທຶກ
                    </b-button>
                  
                  </b-field>
                </b-field>
              </div>
                
              <span style="font-size: 16px; font-weight: bold;" v-if="getMarketProductTotalQuantity(productSubList) == selectedProductGroupQuantity">ລາຍການສິນຄ້າ  
                
              </span>
              <!-- {{ isGroupBuy }} -- {{ selectedProductGroupQuantity }} -->
              <!-- <table class="table is-fullwidth is-narrow is-small" v-if="isGroupBuy==1"> -->
              <!-- <table class="table is-fullwidth is-narrow is-small" >
                <thead>
                  <tr>
                  
                    <th class="has-text-centered " width="5%">
                      #
                    </th>
                    <th class="has-text-left " width="70%">
                      ສິນຄ້າ
                    </th>
                    <th class="has-text-right " width="25%">
                      ຈຳນວນ
                    </th>
                  
                  </tr>
                </thead>
                <tbody>
                  <tr
                  >
                    <td class="has-text-centered">1</td>
                    <td class="has-text-left">
                      <span style="font-weight: bold; font-size: 18px;">{{ selectedProductName }}</span>
                      
                    </td>
                    <td class="has-text-right">
                      {{ selectedProductGroupQuantity | formatNumberLocal }}  {{ selectedProductStandardUnit }}
                    </td>
                  
                  </tr>
                </tbody>
              </table> -->
              <!-- <table class="table is-fullwidth is-narrow is-small" v-if="isGroupBuy==0"> -->
              <table class="table is-fullwidth is-narrow is-small" v-if="getMarketProductTotalQuantity(productSubList) == selectedProductGroupQuantity">  
                <thead>
                  <tr>
                  
                    <th class="has-text-centered " width="5%">
                      #  
                    </th>
                    <th class="has-text-left " width="70%">
                      ສິນຄ້າຍ່ອຍ
                    </th>
                    <th class="has-text-right " width="10%">
                      x
                    </th>
                    <th class="has-text-right " width="25%">
                      ຈຳນວນ
                    </th>
                  
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in productSubList"
                    :key="data.ID"
                  >
                    <td class="has-text-centered">{{ index + 1 }}</td>
                    <td class="has-text-left">
                      <span style="font-weight: bold; font-size: 18px;">{{ data.PRODUCTNAME_SUB }}</span><br>
                      <span style="color: red;">{{ data.COMPANY }}</span>
                      
                    </td>
                    <td class="has-text-right">
                      x{{ data.QUANTITY | formatNumberLocal }}
                    </td>
                    <td class="has-text-right">
                      {{ data.TOIALQUANTITY | formatNumberLocal }} <span style="color: red; font-weight: bold;"> {{ data.UNIT }} </span> 
                    </td>
                  
                  </tr>  
                </tbody>
                <tfoot>   
                  <tr >
                    <th colspan="3" class="has-text-right">
                      ລວມ 
                    </th>
                    <th  class="has-text-right">
                      <!-- {{ _.sumBy(productSubList, i => i["TOIALQUANTITY"]*1) | formatNumberLocal }} <span style="color: red; font-weight: bold;"> {{ productSubUnit }}</span> -->
                      {{ selectedProductGroupQuantity | formatNumberLocal }} <span style="color: red; font-weight: bold;"> </span>
                      
                    </th>            
                  </tr>

                  
                </tfoot>

              </table>
              <div style=" margin-top: 30px;">
                <span style="font-size: 16px; font-weight: bold;">ປະຫວັດການຊື້</span>  
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                    
                      <th class="has-text-centered " width="5%">
                        #
                      </th>
                      <th class="has-text-centered " width="30%">
                        ເວລາ
                      </th>
                      <th class="has-text-right " width="30%">
                        ຈຳນວນ
                      </th>
                      <th class="has-text-right " width="30%">
                        ຈຳນວນເງິນ
                      </th>
                    
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in productSubBuyHistory"
                      :key="data.ID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td class="has-text-centered">
                        {{ data.TXTIME }}
                        
                      </td>
                      <td class="has-text-right">
                        
                        <span v-if="data.NEED_TO_UPDATE ==0">{{ data.QUANTITY | formatNumberLocal }}</span>
                        <span v-else-if="data.NEED_TO_UPDATE ==1" style="text-align: right;">
                          <b-input
                              v-model.trim="data.QUANTITY"
                              type="number"  
                              min="0"
                              pattern="[0-9]+"
                              class="text-right-input"
                              placeholder="ຈຳນວນ"
                              style="width: 100px; margin-top: 5px; text-align: right;"
                            ></b-input>
                        </span>
                      </td>
                      <td class="has-text-right">
                        <span v-if="data.NEED_TO_UPDATE ==0">{{ data.TOTALPRICE | formatNumberLocal }}</span>
                        <span v-else-if="data.NEED_TO_UPDATE ==1" style="text-align: right;">
                          <b-input
                              v-model.trim="data.TOTALPRICE"
                              type="number"  
                              min="0"
                              pattern="[0-9]+"
                              class="text-right-input"
                              placeholder="ຈຳນວນເງິນ"
                              style="width: 100px; margin-top: 5px; text-align: right;"
                            ></b-input>
                        </span>
                        <br>
                        <b-field v-if="data.ISFROMSTOCK==0" style="float: right">
                          <b-button v-if="data.NEED_TO_UPDATE ==0 && data.ISCONFIRM==0"
                            class="btn-group-margin"
                            type="is-primary"
                            @click="updatePurchaseMarketQuantityForm(index)"  
                            >ແກ້ໄຂ
                          </b-button>
                          <b-button v-else-if="data.NEED_TO_UPDATE ==1"
                            class="btn-group-margin"
                            type="is-primary"
                            @click="updatePurchaseMarketQuantity(data.PURCHASEMARKETID, data.QUANTITY,data.TOTALPRICE, 1, data.PRODUCTID, data.MARKETBATCHID, data.REDATE, data.MARKETID, data.ID)"
                            >ແກ້ໄຂ
                          </b-button>

                          <b-button v-if="data.NEED_TO_UPDATE ==0 && data.ISCONFIRM==0"
                            class="btn-group-margin"
                            type="is-danger" 
                            @click="cancelPurchaseMarketHistory(data.ID,data.PURCHASEMARKETID,data.PRODUCTID)"
                            >ຍົກເລີກ
                          </b-button>
                        </b-field>
                        <b-field v-else style="color: red; font-weight: bold; float: right">  
                          ລາຍການຈາກ ສາງສິນຄ້າ
                        </b-field>
                          
                      </td>
                    
                    </tr>
                  </tbody>
                  <tfoot>
                  <tr v-if="selectedProductQuantity > selectedProductMarketQuantity" style="background-color: yellow;">
                    <th colspan="2" class="has-text-right">
                      ລວມ 
                    </th>
                    <th  class="has-text-right">
                      <span >
                        {{ m_quantity  | formatNumberLocal}}/ {{ _.sumBy(productSubBuyHistory, i => parseFloat(i["QUANTITY"])) | formatNumberLocal }} 
                      </span>
                       
                      
                     
                    </th> 
                    <th  class="has-text-right">
                      {{ _.sumBy(productSubBuyHistory, i => i["TOTALPRICE"]) | formatNumberLocal }}
                    </th>            
                  </tr>

                  <tr v-else>
                    <th colspan="2" class="has-text-right">
                      ລວມ 
                    </th>
                    <th  class="has-text-right">
                      <span >
                        {{ m_quantity  | formatNumberLocal}}/ {{ _.sumBy(productSubBuyHistory, i => parseFloat(i["QUANTITY"])) | formatNumberLocal }} 
                      </span>
                       
                      
                     
                    </th> 
                    <th  class="has-text-right">
                      {{ _.sumBy(productSubBuyHistory, i => i["TOTALPRICE"]) | formatNumberLocal }}
                    </th>            
                  </tr>
                </tfoot>
                </table>
              </div>
              
                
            </b-tab-item>
            
            
          </b-tabs>
        </b-tab-item>
        <b-tab-item label="ການອັບເດດລາຄາ">
         
          <b-tabs v-model="activeSubTab">
        
            <b-tab-item label="ຍົກ(16-18)">
              <div class="columns">
                <div class="column">
                 
                </div>

                <div class="column" style=" padding: 0; margin: 0; text-align: right;">
            
                  <!-- <b-button
                    class="btn-group-margin"
                    type="is-primary"
                    size="is-small"
                    @click="savePrice(1)"
                    >ບັນທຶກລາຄາ  
                  </b-button> -->
                </div>
              </div>
              <table class="table is-fullwidth is-narrow is-small">
                <thead>
                  <tr>
                  
                    <th class="has-text-left " width="40%">
                      ສິນຄ້າ
                    </th>
                    <th class="has-text-centered " width="60%">
                      ລາຄາ
                    </th>
                  
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in productPromotionList"
                    :key="data.ID"
                  >
                    <td class="has-text-left">
                      {{ data.NAME }}<br>
                      <b-field style="text-align: left;" v-if="data.B_UNITPRICE1_ORIGINAL != null || data.B_UNITPRICE2_ORIGINAL != null">
                        <b-button v-if="data.B_UNITPRICE_NEED_UPDATE ==0"
                          class="btn-group-margin"
                          type="is-danger"
                          size="is-small"
                          @click="updatePriceForm(index)"
                          > ແກ້ໄຂລາຄາ
                        </b-button>
                        <b-button v-else
                          class="btn-group-margin"
                          type="is-primary"
                          size="is-small"
                          @click="updatePrice(data)"
                          > ແກ້ໄຂລາຄາ
                        </b-button>
                        

                      </b-field>

                      <b-field v-else>
                        <b-button  
                          class="btn-group-margin"
                          type="is-primary"
                          size="is-small"
                          @click="savePrice(1)"
                          >ບັນທຶກລາຄາ  
                        </b-button>
                      </b-field>

                      

                    </td>
                    <td class="has-text-centered"  >
                      <b-field v-if="data.B_UNITPRICE1_ORIGINAL == null || data.B_UNITPRICE_NEED_UPDATE ==1" >
                        <b-input
                          v-model.trim="data.B_UNITPRICE1"
                          type="number"  
                          min="0"
                          pattern="[0-9]+"
                          class="text-right-input"
                          placeholder="ລາຄາຖືກສຸດ"
                          style="width: 100%;"
                        >
                        </b-input>
                      </b-field>
                      <b-field v-else style="text-align: right;">
                        {{ data.B_UNITPRICE1 | formatNumberLocal }}
                      </b-field>
                      
                      <b-field v-if="data.B_UNITPRICE2_ORIGINAL == null || data.B_UNITPRICE_NEED_UPDATE ==1" >
                        <b-input
                          v-model.trim="data.B_UNITPRICE2"
                          type="number"  
                          min="0"
                          pattern="[0-9]+"
                          class="text-right-input"
                          placeholder="ລາຄາແພງສຸດ"
                          style="width: 100%; margin-top: 5px;"
                        >
                        </b-input>
                      </b-field>
                      <b-field v-else style="text-align: right;">
                        {{ data.B_UNITPRICE2 | formatNumberLocal }}
                      </b-field>
                      
                    </td>
                  
                  </tr>
                </tbody>
              </table>
             
            </b-tab-item>
            <b-tab-item label="ຍົກ(1-3)">
            
              
              
            </b-tab-item>
            <b-tab-item label="ຍ່ອຍ(4-6)">
              
              
                
            </b-tab-item>
            
            
          </b-tabs>
           
        </b-tab-item>
        
        
      </b-tabs>
    </div>

    <div v-if="isPopupVisible" class="popup" @click="hidePopup">
      <span class="close" @click.stop="hidePopup">&times;</span>
      <img :src="popupImgSrc" class="popup-content">
    </div>

    <div class="contain print-only page-break">
      <div class="contain">
        <div class="columns">  
          <div class="column">
            <b-field style="font-size: 20px;">ລາຍການເຄື່ອງອອກສາງ ວັນທີ {{ dateFormatter(selectedPurchaseDate) }}</b-field>
          </div>
        </div>
        <div class="columns">  
          
          <div class="column">
            <table class="table is-fullwidth is-narrow is-small">
              <thead>
                <tr>
                  <th class="has-text-left set-border" width="40%">
                    ສິນຄ້າ
                  </th>
                  <th class="has-text-centered set-border" width="10%">
                    ຈຳນວນ
                  </th>
                  <th class="has-text-centered set-border" width="15%">
                    ຍັງເຫຼືອ
                  </th>
                  <th class="has-text-centered set-border" width="15%">
                    ໝາຍເຫດ
                  </th>
                  
                  
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in productList"
                  :key="data.PRODUCTANDTYPE"
                >
                  <td class="has-text-left set-border">
                    {{index +1 }}. {{ data.PRODUCTNAME  }} 
                  
                    
                  </td> 
                  <td class="has-text-right set-border">  
                        <span style=" font-weight: bold;">{{ data.QUANTITY | formatNumberLocal }}</span>  {{ data.UNIT }}
                        
                  </td>
                  <td class="has-text-right set-border">  
                       
                        
                  </td>
                  <td class="has-text-right set-border">  
                       
                        
                      </td>
                  
                </tr>
              </tbody>
              
            </table>
          </div>
        </div>
      </div>
    </div>
  
    
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
// import { BFormSelect } from 'bootstrap-vue'
import Multiselect from "vue-multiselect";
import moment from "moment";
//import { BIconArrowRightSquare } from "bootstrap-vue";

// import PrintSummaryTable from "@/components/PrintSummaryTable.vue";

export default {
  components: {Multiselect },
  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      username: null,
      activeTab: 0,
      activeSubTab: 0,
      activeSub2Tab: 0,
      activeSub3Tab: 0,


      activeSub2TabList: 0,
      purchaselist: [],

      photopath:
        process.env.NODE_ENV === "production"
          ? "https://agrilao.com/manager-main/api/uploads/"
          // : "http://localhost/agrilao-manager/api/uploads/",
          : "https://agrilao.com/manager-main/api/uploads/",

      selectedPurchaseDate: null,
      selectedPurchaseDateAmount: null,
      selectedPurchaseMarketBatchid: null,
      selectedMarketID: null,
      selectedPurchaseMarketID: null,
      selectedProductID : null,
      selectedProductName : null,
      productList: [],
      productRemainConfirm: [],
      productSubList: [],
      productSubUnit: null,
      productSubBuyHistory: [],
      productPromotionList: [],
      productAllList: [],
      isConfirmed: 0,
      isGroupBuy: 0,
      selectedProductGroupQuantity: 0,

      isPopupVisible: false,
      popupImgSrc: '',
      accountBalance: 0,

      productQuantity: 0,
      productTotalPrice: null,
      m_quantity: 0,
      selectedProductQuantity: 0,
      selectedProductMarketQuantity: 0,
      selectedProductQuantityRemain: 0,
      selectedProductMarketStatus: null,

      selectedProductStandardUnit: 0,

      marketList: [],
      istransferProduct : 0,
      selectedTransferAmount: 0,

      isPrintData: 0,

      sysAmount: 0,
      checkStatus: 0,
      diffAmount: 0,
      isEditCheckAmount: 0,
      isArrivedLaoMarket: 0,
      laomarketttime: null,

      nobuyList: [],
      buySomeList: [],
      buyAllList: [],

      MOREMARKETTIME: null,
      
    };
  },
  methods: {
    checkInMarket(){ 
      this.$swal({
        title: "ຕ້ອງການດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#FF3860",
        cancelButtonColor: "#F7C325", 
        reverseButtons: true
      }).then((result) => {
        if (result.value) {

          this.$swal({
            title: "ໃສ່ລະຫັດເພື່ອຢືນຢັນ",
            input: 'password',  // Input type password
            inputPlaceholder: 'ລະຫັດຜ່ານ',
            inputAttributes: {
              autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'ຢືນຢັນ',
            cancelButtonText: 'ຍົກເລີກ',
            confirmButtonColor: "#41B883",
            cancelButtonColor: "#F7C325",  
            reverseButtons: true,  
            preConfirm: (password) => {
              if (!password) {
                this.$swal.showValidationMessage('ກະລຸນາໃສ່ລະຫັດຢືນຢັນ');  
              } else {
                return password;
              }  
            }
          }).then((secondResult) => {
            if (secondResult.value) {
              const password = secondResult.value;

                if (password==="999888") {

                  if (result.value) {         
                    var params = {
                      redate: this.selectedPurchaseDate,
                      username: this.username,
                    };

                    // console.log("params: " + JSON.stringify(params))
                    const loadingComponent = this.$loading.open({});  
                    RestAPI.checkInMarket(params)
                      .then((res) => {
                        loadingComponent.close();

                        if(res.data.code=="00"){

                          this.purchaseProductList(this.selectedPurchaseDate, this.selectedPurchaseMarketBatchid, 2);              
                          this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
                        }else{
                          this.$swal("ດຳເນີນການ ບໍ່ສຳເລັດ", "", "error");
                        }
                        
                      
                      })
                      .catch((error) => {
                        loadingComponent.close();
                        console.log(error);
                        if (error == "Error: Request failed with status code 400") {
                          this.$swal("Check Input Data", "", "error");
                        } else {
                          this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                        }
                      });
                  }
                }else{
                  this.$swal("ລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ", "", "error");
                }
            
              }
            });

          }
          
        });
        
    },
    editMarketAccountForm(){
      this.isEditCheckAmount = 1;
    },

    editMarketAccount(){
      if(this.sysAmount ==0 || this.sysAmount == null) {
        this.$swal("ປ້ອນຈຳນວນທີ່ໃຊ້ບັນຊີ ກ່ອນ", "", "error");
        return false;
      }
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#FF3860",
        cancelButtonColor: "#F7C325", 
        reverseButtons: true
      }).then((result) => {
        if (result.value) {         
          var params = {
            marketbatchid: this.selectedPurchaseMarketBatchid,
            purchaserid: this.selectedPurchaseMarketID,
            redate: this.selectedPurchaseDate,
            systemamount: this.sysAmount,
            accountamount: this.selectedPurchaseDateAmount,
            username: this.username,
          };

          // console.log("params: " + JSON.stringify(params))
            
          RestAPI.editMarketAccount(params)
            .then((res) => {
              if(res.data.result=="success"){
                console.log("res.data.result: " + JSON.stringify(res.data.checkdata))

                this.checkStatus = res.data.checkdata.CHECKSTATUS;
                this.sysAmount = res.data.checkdata.SYSTEMAMOUNT;
                this.diffAmount = this.selectedPurchaseDateAmount-this.sysAmount;
                this.isEditCheckAmount = 0;
                this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              }else{
                this.$swal("ດຳເນີນການ ບໍ່ສຳເລັດ", "", "error");
              }
              
             
             })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    sysAccountPress(){
      this.diffAmount = this.selectedPurchaseDateAmount-this.sysAmount;
    },
    saveMarketAccount(){
      if(this.sysAmount ==0 || this.sysAmount == null) {
        this.$swal("ປ້ອນຈຳນວນທີ່ໃຊ້ບັນຊີ ກ່ອນ", "", "error");
        return false;
      }
      
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#FF3860",
        cancelButtonColor: "#F7C325", 
        reverseButtons: true
      }).then((result) => {
        if (result.value) {         
          var params = {
            marketbatchid: this.selectedPurchaseMarketBatchid,
            purchaserid: this.selectedPurchaseMarketID,
            redate: this.selectedPurchaseDate,
            systemamount: this.sysAmount,
            accountamount: this.selectedPurchaseDateAmount,
            username: this.username,
          };

          // console.log("params: " + JSON.stringify(params))
            
          RestAPI.saveMarketAccount(params)
           .then((res) => {
              if(res.data.result=="success"){
                console.log("res.data.result: " + JSON.stringify(res.data.checkdata))

                this.checkStatus = res.data.checkdata.CHECKSTATUS;
                this.sysAmount = res.data.checkdata.SYSTEMAMOUNT;
                this.diffAmount = this.selectedPurchaseDateAmount-this.sysAmount;
                this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              }else{
                this.$swal("ດຳເນີນການ ບໍ່ສຳເລັດ", "", "error");
              }
              
             
             })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    print() {
      window.print(); 
      
    },
    gobackBuyList(){
      this.isPrintData = 0;
    },
    getPurchaserData(){
      // this.sortPurchaseData("PRODUCTTYPEID asc", "PRODUCTNAME asc");
      this.isPrintData = 1;

    },

    // sortPurchaseData(key, order = 'asc') {
    //     this.productList.sort((a, b) => {
    //       let valueA = a[key];
    //       let valueB = b[key];

    //       // If not numeric, sort as strings
    //       valueA = valueA ? String(valueA) : '';
    //       valueB = valueB ? String(valueB) : '';   

    //       return order === 'asc' 
    //         ? valueB.localeCompare(valueA) 
    //         : valueA.localeCompare(valueB);
    //     });
    // },

    sortPurchaseData(...args) {
      this.productList.sort((a, b) => {
          for (let arg of args) {
              let [key, order] = arg.split(' '); // Split key and order
              let valueA = a[key];
              let valueB = b[key];

              // If not numeric, sort as strings
              valueA = valueA ? String(valueA) : '';
              valueB = valueB ? String(valueB) : '';

              // For numeric sorting
              if (!isNaN(valueA) && !isNaN(valueB)) {
                  valueA = parseFloat(valueA);
                  valueB = parseFloat(valueB);
              }

              // Compare values based on order
              let result = valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
              if (order === 'desc') result *= -1;

              // If the values are different, return the comparison result
              if (result !== 0) return result;
          }
          return 0; // If all compared values are equal, maintain original order
      });
  },
    
    getMarketProductTotalQuantity(items) {  
      // const total = _.sumBy(items, (item) => parseFloat(item.TOIALQUANTITY) || 0);
      // return parseFloat(total.toFixed(1)); // Fix to one decimal place
      // let total = 0;
      // for (let i = 0; i < items.length; i++) {
      //     total += parseFloat(items[i].TOIALQUANTITY) || 0;
      // }
      // return parseFloat(total.toFixed(1)); // Fix to one decimal place

      const total = items.reduce((sum, item) => {
          return sum + (parseFloat(item.TOIALQUANTITY) || 0);
      }, 0);
      return parseFloat(total.toFixed(1)); // Fix to one decimal place
    }, 

    goToAnotherMarket(){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#FF3860",
        cancelButtonColor: "#F7C325", 
        reverseButtons: true
      }).then((result) => {
        if (result.value) {         
          var params = {
            username: this.username,
          };
            
          RestAPI.goToAnotherMarket(params)
            .then(() => {
              // load market that go
              this.$swal({
                title: "ສຳເລັດ",
                text: "ດຳເນີນການ ສຳເລັດ!",
                icon: "success",
                timer: 500,
                showConfirmButton: false, 
              });
             
             })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    
    // transferProduct(index){

    //   // console.log("remainQuantity "+  this.productList[index].REMAINQUANTITY);

    //   this.$swal({
    //     title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?++",
    //     showCancelButton: true,
    //     showCloseButton: true,
    //     confirmButtonText: "ຕ້ອງການ",
    //     cancelButtonText: "ບໍ່ຕ້ອງການ",
    //     confirmButtonColor: "#FF3860",
    //     cancelButtonColor: "#F7C325", 
    //     reverseButtons: true
    //   }).then((result) => {
    //     if (result.value) {         

    //       if(this.nobuyList[index].REMAINQUANTITY  > (this.nobuyList[index].QUANTITY - this.nobuyList[index].MARKETQUANTITY )){
    //         this.$swal("ໂອນເກີນຈຳນວນ", "", "error");
    //         return false;
    //       }

    //       if(this.nobuyList[index].MARKETID != this.nobuyList[index].SELECTEDMARKET.ID ){
    //         var params = {
    //           purchasemarketid: this.nobuyList[index].PURCHASEMARKETID,
    //           marketbatchid: this.selectedPurchaseMarketBatchid,
    //           redate: this.nobuyList[index].REDATE,
    //           productid: this.nobuyList[index].PRODUCTID,
    //           oldmarketid: this.nobuyList[index].MARKETID,
    //           newmarketid: this.nobuyList[index].SELECTEDMARKET.ID,
    //           quantity: this.nobuyList[index].QUANTITY,
    //           marketquantity: this.nobuyList[index].MARKETQUANTITY,
    //           remainquantity: this.nobuyList[index].REMAINQUANTITY,
    //           username: this.username,
    //         };
    //         //console.log("params: " + JSON.stringify(params))
            
    //           RestAPI.transferMarketBuyProduct(params)   
    //             .then((res) => { 
                 
    //               if(res.data=="notenoughquantity"){
    //                 this.$swal("ບໍ່ມີຈຳນວນໃຫ້ໂອນ, refresh ລະບົບ", "-", "error");
    //                 return false;   
    //               }
    //               // this.purchaseProductList(this.selectedPurchaseDate, this.selectedPurchaseMarketBatchid, 2)   
    //               // this.getMarketPurchaseList();
    //               this.$swal({
    //                 title: "ສຳເລັດ",
    //                 text: "ດຳເນີນການ ສຳເລັດ!",
    //                 icon: "success",
    //                 timer: 500,
    //                 showConfirmButton: false, 
    //               });
                
    //             })
    //             .catch((error) => {
    //               console.log(error);
    //               if (error == "Error: Request failed with status code 400") {
    //                 this.$swal("Check Input Data", "", "error");
    //               } else {
    //                 this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
    //               }
    //             });
    //       }else{
    //           this.$swal("ກະລຸນາເລືອກ ຕະຫຼາດໃຫ້ຖືກຕ້ອງ", "", "error");
    //       }
            
    //     }
    //   });   


      
    // },

    transferProduct(index){

      // console.log("remainQuantity "+  this.productList[index].REMAINQUANTITY);

      this.$swal({
        title: "ຕ້ອງການດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#FF3860",
        cancelButtonColor: "#F7C325", 
        reverseButtons: true
      }).then((result) => {
        if (result.value) {         

          if(this.nobuyList[index].REMAINQUANTITY  > (this.nobuyList[index].QUANTITY - this.nobuyList[index].MARKETQUANTITY )){
            this.$swal("ໂອນເກີນຈຳນວນ", "", "error");
            return false;
          }

          if(this.nobuyList[index].MARKETID != this.nobuyList[index].SELECTEDMARKET.ID ){
            var params = {
              purchasemarketid: this.nobuyList[index].PURCHASEMARKETID,
              marketbatchid: this.selectedPurchaseMarketBatchid,
              redate: this.nobuyList[index].REDATE,
              productid: this.nobuyList[index].PRODUCTID,
              oldmarketid: this.nobuyList[index].MARKETID,
              newmarketid: this.nobuyList[index].SELECTEDMARKET.ID,
              quantity: this.nobuyList[index].QUANTITY,
              marketquantity: this.nobuyList[index].MARKETQUANTITY,
              remainquantity: this.nobuyList[index].REMAINQUANTITY,
              username: this.username,
            };
            // console.log("params: " + JSON.stringify(params))
            
              RestAPI.transferMarketBuyProduct(params)
                .then((res) => {
                  
                  if(res.data=="notenoughquantity"){
                    this.$swal("ບໍ່ມີຈຳນວນໃຫ້ໂອນ, refresh ລະບົບ", "-", "error");
                    return false;   
                  }
                  
                  this.purchaseProductList(this.selectedPurchaseDate, this.selectedPurchaseMarketBatchid, 2)
                  this.getMarketPurchaseList();
                  this.$swal({
                    title: "ສຳເລັດ",
                    text: "ດຳເນີນການ ສຳເລັດ!",
                    icon: "success",
                    timer: 500,
                    showConfirmButton: false, 
                  });
                
                })
                .catch((error) => {
                  console.log(error);
                  if (error == "Error: Request failed with status code 400") {
                    this.$swal("Check Input Data", "", "error");
                  } else {
                    this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                  }
                });
          }else{
              this.$swal("ກະລຸນາເລືອກ ຕະຫຼາດໃຫ້ຖືກຕ້ອງ", "", "error");
          }
            
        }
      });   


      
    },

    transferProduct2(index){

    // console.log("remainQuantity "+  this.productList[index].REMAINQUANTITY);

    this.$swal({
      title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: "ຕ້ອງການ",
      cancelButtonText: "ບໍ່ຕ້ອງການ",
      confirmButtonColor: "#FF3860",
      cancelButtonColor: "#F7C325", 
      reverseButtons: true
    }).then((result) => {
      if (result.value) {         

        if(this.buySomeList[index].REMAINQUANTITY  > (this.buySomeList[index].QUANTITY - this.buySomeList[index].MARKETQUANTITY )){
          this.$swal("ໂອນເກີນຈຳນວນ", "", "error");
          return false;
        }

        if(this.buySomeList[index].MARKETID != this.buySomeList[index].SELECTEDMARKET.ID ){
          var params = {
            purchasemarketid: this.buySomeList[index].PURCHASEMARKETID,
            marketbatchid: this.selectedPurchaseMarketBatchid,
            redate: this.buySomeList[index].REDATE,
            productid: this.buySomeList[index].PRODUCTID,
            oldmarketid: this.buySomeList[index].MARKETID,
            newmarketid: this.buySomeList[index].SELECTEDMARKET.ID,
            quantity: this.buySomeList[index].QUANTITY,
            marketquantity: this.buySomeList[index].MARKETQUANTITY,
            remainquantity: this.buySomeList[index].REMAINQUANTITY,
            username: this.username,
          };
          console.log("params: " + JSON.stringify(params))
          
            RestAPI.transferMarketBuyProduct(params)
              .then(() => {
                this.purchaseProductList(this.selectedPurchaseDate, this.selectedPurchaseMarketBatchid, 2)
                this.getMarketPurchaseList();
                this.$swal({
                  title: "ສຳເລັດ",
                  text: "ດຳເນີນການ ສຳເລັດ!",
                  icon: "success",
                  timer: 500,
                  showConfirmButton: false, 
                });
              
              })
              .catch((error) => {
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                }
              });
        }else{
            this.$swal("ກະລຸນາເລືອກ ຕະຫຼາດໃຫ້ຖືກຕ້ອງ", "", "error");
        }
          
      }
    });   



    },
    
    transferProductForm(index){
      // this.productList[index].NEED_TO_UPDATE = 1;
      this.nobuyList[index].NEED_TO_UPDATE = 1;
      // console.log("transferProductForm: "+index)
    },

    transferProductForm2(index){
      // this.productList[index].NEED_TO_UPDATE = 1;
      this.buySomeList[index].NEED_TO_UPDATE = 1;
      // console.log("transferProductForm: "+index)
    },
    cancelPurchaseMarketHistory(HISTORYID,PURCHASEMARKETID, PRODUCTID){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#FF3860",
        cancelButtonColor: "#F7C325", 
        reverseButtons: true
      }).then((result) => {
        if (result.value) {         
          var params = {
            historyid: HISTORYID,
            purchasemarketid: PURCHASEMARKETID,
            username: this.username,
          };
            
          RestAPI.cancelPurchaseMarketHistory(params)
            .then(() => {
              this.purchaseProductSubList(PURCHASEMARKETID, PRODUCTID, this.selectedMarketID, this.selectedProductQuantity, this.selectedProductMarketQuantity, this.selectedProductMarketStatus);
              this.purchaseProductList(this.selectedPurchaseDate, this.selectedPurchaseMarketBatchid, 1);
              // this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              this.getMarketPurchaseList();
              this.$swal({
                title: "ສຳເລັດ",
                text: "ດຳເນີນການ ສຳເລັດ!",
                icon: "success",
                timer: 500,
                showConfirmButton: false, 
              });
             
             })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },


    getPurchaserAccountBalance() {
    RestAPI.getPurchaserAccountBalance( this.username)
      .then((res) => {
        this.accountBalance = res.data;
        // console.log("accountBalance: " + JSON.stringify(res.data))
        // console.log("res: " + JSON.stringify(res.data))
      })
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
    },

    showPopup(PHOTONAME) {
      this.popupImgSrc = this.getImgUrl('products/' + PHOTONAME);
      this.isPopupVisible = true;
      // console.log("PHOTONAME: "+ PHOTONAME)
    },
    hidePopup() {
      this.isPopupVisible = false;
    },
    updatePrice(data){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#41B883",
        cancelButtonColor: "#F7C325", 
        reverseButtons: true
      }).then((result) => {
        if (result.value) {         
          var params = {
            productPromotionList: data,
            username: this.username,
          };
          // console.log("params: " +JSON.stringify(params))
            
          RestAPI.updatePrice(params)
            .then(() => {
              this.productUpdatePriceList();
              // this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              this.$swal({
                title: "ສຳເລັດ",
                text: "ດຳເນີນການ ສຳເລັດ!",
                icon: "success",
                timer: 500,
                showConfirmButton: false, 
              });
             
             })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },


    updatePriceForm(index){
      // console.log("index: " + index)
      // console.log("this.productPromotionList before: " +JSON.stringify(this.productPromotionList))
      this.productPromotionList[index].B_UNITPRICE_NEED_UPDATE = 1;
      // console.log("this.productPromotionList after: " +JSON.stringify(this.productPromotionList))
    },
    clearPrice(ID){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#FF2B56",
        cancelButtonColor: "#F7C325", 
        reverseButtons: true
      }).then((result) => {
        if (result.value) {         
          var params = {
            productpriceid: ID,
            username: this.username,
          };
            
          RestAPI.clearPrice(params)
            .then(() => {
              this.productUpdatePriceList();
              // this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");

              this.$swal({
                title: "ສຳເລັດ",
                text: "ດຳເນີນການ ສຳເລັດ!",
                icon: "success",
                timer: 500,
                showConfirmButton: false, 
              });
             })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    savePrice(type){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#41B883",
        cancelButtonColor: "#F7C325", 
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          var params;
          if(type==1){
              params = {
                productPrice: this.productPromotionList,
                username: this.username,
              };
          }else{
              params = {
                productPrice: this.productPromotionList,
                username: this.username,
              };
          }
          
          RestAPI.savePrice(params)
            .then(() => {
              // this.purchaseProductList(this.selectedPurchaseDate);
              this.productUpdatePriceList();
              // this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");

              this.$swal({
                title: "ສຳເລັດ",
                text: "ດຳເນີນການ ສຳເລັດ!",
                icon: "success",
                timer: 500,
                showConfirmButton: false, 
              });

             })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },

    productUpdatePriceList() {

      RestAPI.productUpdatePriceList( this.username)
        .then((res) => {
          this.productPromotionList = res.data.promotionlist;
          this.productAllList = res.data.alllist;
          // console.log("res.data: " + JSON.stringify(res.data))
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    // confirmAllPurchaseMarket(){
    //   this.$swal({
    //     title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
    //     showCancelButton: true,
    //     showCloseButton: true,
    //     confirmButtonText: "ຕ້ອງການ",
    //     cancelButtonText: "ບໍ່ຕ້ອງການ",
    //     confirmButtonColor: "#41B883",
    //     cancelButtonColor: "#F7C325", 
    //     reverseButtons: true
    //   }).then((result) => {
    //     if (result.value) {
    //       var params = {
    //         productlist: this.productList,
    //         username: this.username,
    //       };
    //       RestAPI.confirmAllPurchaseMarket(params)
    //         .then(() => {
    //           this.purchaseProductList(this.selectedPurchaseDate, this.selectedPurchaseMarketBatchid, 3);
    //           this.getPurchaserAccountBalance();

    //           this.$swal({
    //             title: "ສຳເລັດ",
    //             text: "ດຳເນີນການ ສຳເລັດ!",
    //             icon: "success",
    //             timer: 500,
    //             showConfirmButton: false, 
    //           });
             
    //          })
    //         .catch((error) => {
    //           console.log(error);
    //           if (error == "Error: Request failed with status code 400") {
    //             this.$swal("Check Input Data", "", "error");
    //           } else {
    //             this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
    //           }
    //         });
    //     }
    //   });
    // },

    confirmAllPurchaseMarket() {
      this.$swal({
        title: "ຕ້ອງການດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#41B883",
        cancelButtonColor: "#F7C325",
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          // Show a second confirmation dialog with a password input
          this.$swal({
            title: "ໃສ່ລະຫັດເພື່ອຢືນຢັນ",
            input: 'password',  // Input type password
            inputPlaceholder: 'ລະຫັດຜ່ານ',
            inputAttributes: {
              autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'ຢືນຢັນ',
            cancelButtonText: 'ຍົກເລີກ',
            confirmButtonColor: "#41B883",
            cancelButtonColor: "#F7C325",
            reverseButtons: true,
            preConfirm: (password) => {
              if (!password) {
                this.$swal.showValidationMessage('ກະລຸນາໃສ່ລະຫັດຢືນຢັນ');
              } else {
                return password;
              }
            }
          }).then((secondResult) => {
            if (secondResult.value) {
              // Check password before proceeding (you can validate with an API)
              const password = secondResult.value;
              
              // Example API validation (replace with your actual API call)
  
                if (password==="88998899") {
                  // Proceed with the action after successful password validation
                  var params = {
                    marketbatchid:  this.selectedPurchaseMarketBatchid,
                    redate: this.selectedPurchaseDate, 
                    purchaserid: this.selectedPurchaseMarketID,
                    username: this.username,
                  };
                  // console.log("params: " +JSON.stringify(params))
                  RestAPI.confirmAllPurchaseMarket(params)
                    .then(() => {
                      this.purchaseProductList(this.selectedPurchaseDate, this.selectedPurchaseMarketBatchid, 3);
                      this.getPurchaserAccountBalance();
                      this.$swal({
                        title: "ສຳເລັດ",
                        text: "ດຳເນີນການ ສຳເລັດ!",
                        icon: "success",
                        timer: 500,
                        showConfirmButton: false,
                      });
                    })
                    .catch((error) => {
                      console.log(error);
                      if (error == "Error: Request failed with status code 400") {
                        this.$swal("Check Input Data", "", "error");
                      } else {
                        this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                      }
                    });
                } else {
                  this.$swal("ລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ", "", "error");
                }
                
            }
          });
        }
      });
    },

    updatePurchaseMarketQuantityForm(index){  
      this.productSubBuyHistory[index].NEED_TO_UPDATE = 1;
      // console.log("index: " +index)
      // console.log("this.productList[index]: " +this.productList[index])
    },

    updatePurchaseMarketQuantity(PURCHASEMARKETID = null, QUANTITY= null, TOTALPRICE= null, TYPE, PRODUCTID = null,MARKETBATCHID = null, REDATE = null, MARKETID= null, HISTORYID= null){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#41B883",
        cancelButtonColor: "#F7C325", 
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
         
          
          var params;

          if(TYPE == 2){
            if (this.selectedProductQuantityRemain === null || this.selectedProductQuantityRemain <= 0 || this.productTotalPrice === null || this.productTotalPrice <= 0) {
              this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ+", "", "error");
              return false;
            }

            params = {
              test: 1,
              type: TYPE,
              purchasemarketid: this.selectedPurchaseMarketID,
              quantity: this.selectedProductQuantityRemain,
              totalprice: this.productTotalPrice,
              productid: this.selectedProductID,
              marketbatchid: this.selectedPurchaseMarketBatchid,
              redate: this.selectedPurchaseDate,
              marketid: this.selectedMarketID,
              username: this.username,
            };


            console.log("selectedPurchaseMarketID: " +this.selectedPurchaseMarketID); 
            
          }else{
            if (QUANTITY === null || QUANTITY <= 0 || TOTALPRICE === null || TOTALPRICE <= 0) {
              this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ-", "", "error");
              return false;
            }
            params = {
              test: 2,
              type: TYPE,
              purchasemarketid: PURCHASEMARKETID,
              quantity: QUANTITY,
              totalprice: TOTALPRICE,
              productid: PRODUCTID,
              marketbatchid: MARKETBATCHID,
              redate: REDATE,
              marketid: MARKETID,
              historyid: HISTORYID,
              username: this.username,
            };

            this.selectedPurchaseMarketID = PURCHASEMARKETID;
            this.selectedProductID = PRODUCTID;

          }

          // console.log("PURCHASEMARKETID: " + PURCHASEMARKETID)
          // console.log("PRODUCTID: " + PRODUCTID)
          console.log("params: " +JSON.stringify(params))   
          
          RestAPI.updatePurchaseMarketQuantity(params)
            .then(() => {
              this.productQuantity = 0;
              this.productTotalPrice = null;
              this.purchaseProductList(this.selectedPurchaseDate, this.selectedPurchaseMarketBatchid, 1); // 1 ເພື່ອບໍ່ໃຫ້ແລ່ນໄປຫນ້າກ່ອນຫນ້າ
              this.purchaseProductSubList(this.selectedPurchaseMarketID,  this.selectedProductID,this.selectedMarketID, this.selectedProductQuantity, this.selectedProductMarketQuantity, this.selectedProductMarketStatus );
              
              this.getMarketPurchaseList();

              this.selectedProductQuantity;
              this.selectedProductMarketQuantity;
              this.selectedProductQuantityRemain;

              // this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");

              this.$swal({
                title: "ສຳເລັດ",
                text: "ດຳເນີນການ ສຳເລັດ!",
                icon: "success",
                timer: 500,
                showConfirmButton: false, 
              });
              // console.log("PURCHASEMARKETID: " + PURCHASEMARKETID)
              // console.log("PRODUCTID: " + PRODUCTID)
             
             })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },

    purchaseProductSubList(PURCHASEMARKETID,  PRODUCTID, PRODUCTNAME, MARKETID, QUANTITY, MARKETQUANTITY, STATUS, ISGROUPBUY) { 
      
      this.selectedPurchaseMarketID = PURCHASEMARKETID;
      this.selectedProductID = PRODUCTID;
      this.selectedProductName = PRODUCTNAME;   

      this.isGroupBuy = ISGROUPBUY;
      this.selectedProductGroupQuantity = QUANTITY;

      this.selectedMarketID = MARKETID;
      // this.selectedProductQuantity= QUANTITY;
      // this.selectedProductMarketQuantity = MARKETQUANTITY;
      this.selectedProductMarketStatus = STATUS;

      // this.selectedProductQuantityRemain = QUANTITY-MARKETQUANTITY;
      
      
      RestAPI.purchaseProductSubList(PURCHASEMARKETID, PRODUCTID, this.selectedPurchaseMarketBatchid, this.username)
        .then((res) => {
          this.productSubList = res.data.productsubList;
          // this.productSubUnit = res.data.productsubList ? res.data.productsubList[0].UNIT : this.productSubUnit;
          this.productSubUnit = '000';

          this.productSubBuyHistory = res.data.history;
          this.isConfirmed = res.data && res.data.history && res.data.history.length > 0 ? res.data.history[0].ISCONFIRM : 0;
          this.m_quantity = res.data && res.data.history && res.data.history.length > 0 ? res.data.history[0].M_QUANTITY : 0;

          this.selectedProductStandardUnit = res.data.standardunit;
        
          this.selectedProductQuantity= parseFloat(res.data.marketdata.QUANTITY);
          this.selectedProductMarketQuantity = parseFloat(res.data.marketdata.MARKETQUANTITY);
          this.selectedProductQuantityRemain = parseFloat((this.selectedProductQuantity - this.selectedProductMarketQuantity).toFixed(1));

          this.selectedPurchaseDateAmount = res.data.totalprice;


          this.activeSubTab = 2;
          // console.log("res.data: " + JSON.stringify(res.data))
          // console.log("this.selectedProductQuantity: " + JSON.stringify(this.selectedProductQuantity))
          // console.log("this.selectedProductMarketQuantity: " + JSON.stringify(this.selectedProductMarketQuantity))
          // console.log("selectedProductQuantityRemain: " + JSON.stringify(this.selectedProductQuantityRemain))

          
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    
    purchaseProductList(date, batchid, TYPE){
      this.selectedPurchaseDate = date
      this.selectedPurchaseMarketBatchid = batchid;
      if(TYPE == 1){
        this.activeSubTab = 2;
      }else{
        this.activeSubTab = 1;
      }
        
      // console.log("purchaseProductList TYPE: "+TYPE)

      RestAPI.getMarketPurchaseProductList(this.selectedPurchaseMarketID, this.username, date, this.selectedPurchaseMarketBatchid)
        .then((res) => {
      
          this.productList = res.data.list.all;
          this.nobuyList = res.data.list.nobuy;
          this.buySomeList = res.data.list.buysome;
          this.buyAllList = res.data.list.buyall;
          this.MOREMARKETTIME = res.data.list.all ? res.data.list.all[0].MOREMARKETTIME : null;

          // console.log("productList: " + JSON.stringify(this.productList));

          this.productRemainConfirm = res.data.remain;
          this.selectedPurchaseDateAmount = res.data.marketdata.TOTALPRICE;
          this.marketList = res.data.marketList;
          // console.log("res.data.checkdata.CHECKSTATUS: " + JSON.stringify(res.data.checkdata));
          this.checkStatus = res.data.checkdata.CHECKSTATUS;
          this.sysAmount = res.data.checkdata.SYSTEMAMOUNT;
          this.diffAmount = this.selectedPurchaseDateAmount-this.sysAmount;

          this.isArrivedLaoMarket = res.data.laomarket.COUNTROW;
          this.laomarketttime = res.data.laomarket.MOREMARKETTIME;
          // console.log("res.data.marketlist : " + JSON.stringify(res.data))
          
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getMarketPurchaseList() {
      RestAPI.getMarketPurchaseList(this.username)
        .then((res) => {
          // console.log("res.data: " + JSON.stringify(res.data));
          this.purchaselist = res.data;
          this.selectedPurchaseMarketID = res.data[0].MARKETID;  
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    
    getImgUrl(photoname) {
      var photopreview = photoname
        ? this.photopath + photoname
        : this.photopath + "unknown.png";
      return photopreview;
    },

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
    year(date) {
      return new moment(date).format("YYYY");
    },

    
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.getMarketPurchaseList();
    this.productUpdatePriceList();
    this.getPurchaserAccountBalance();  

  },

  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },

    isSummaryOnFirstPage() {
      // Adjust this logic based on the number of rows and your page layout
      const numRowsPerPage = 20; // Change this based on your requirement
      return this.quotationdetaillist.length <= numRowsPerPage;
    },

 

    

    // isLastPage() {
    //   return this.currentPage === this.totalPages;
    // },

    // isFirstPage() {
    //   return this.currentPage === 1;
    // },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.popup {
  display: block;
  position: fixed;
  z-index: 1;
  padding-top: 60px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.9);
}

/* Style for the close button */
.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* Style for the popup content (image) */
.popup-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add animation (optional) */
.popup-content {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
  from { -webkit-transform: scale(0); }
  to { -webkit-transform: scale(1); }
}

@keyframes zoom {
  from { transform: scale(0); }
  to { transform: scale(1); }
}

.text-right-input input {
  text-align: right;
}

.custom-align {
    text-align: right;
}
.asterisk {
  color: red;
}

.set-border {
  border: 1px solid #ddd;
}

/* .summary-footer {
  page-break-before: always;
} */

.modal {
  display: none;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

/* Style for the modal content */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

/* Style for the close button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.border {
    border: 1px solid black;
    padding: 8px;
    text-align: center;
  }

.set-border {
  border: 1px solid black;
}

@media print {
  @page {
    margin-top: 0; /* Set the initial margin for the first page */
  }
}
</style>
